<template>
  <SimpleModuleDashboard
    :module-id="Modules.VENTAS"
    :profile-id="Profiles.PERSONAL"
    include-php-custom
    :actions="dashboardActions"
  />
</template>

<script>
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'

export default {
  components: { SimpleModuleDashboard },
  data: () => ({
    Modules,
    Profiles,
  }),
  computed: {
    dashboardActions() {
      const actions = []
      actions.push(
        { id: 'sales', reference: 'sales', route: 'SalesStaffSales', tone: 'primary' },
        { id: 'salesQuick', reference: 'salesQuick', route: 'SalesStaffSalesQuick', tone: 'secondary' },
        { id: 'salesCounter', reference: 'salesCounter', route: 'SalesStaffSalesCounter', tone: 'success' },
        { id: 'currentsAccounts', reference: 'currentsAccounts', route: 'SalesStaffCurrentsAccounts', tone: 'warning' },
        { id: 'reports', reference: 'reports', route: 'SalesStaffReports', tone: 'primary' },
        { id: 'settings', reference: 'settings', route: 'SalesStaffSettings', tone: 'secondary', group: 'Configuraciones' },
      )
      return actions
    },
  },
}
</script>
